const initialSate = {
    data: 42
}

export default function testReducer(state = initialSate) {
    return state
}